import { useMemo } from 'react'
import {
  KLEAR_AG_GRID_COLUMN_TYPES,
  KLEAR_AG_GRID_DATA_TYPE_DEFINITIONS,
  KLEAR_AG_GRID_DEFAULT_COL_DEF
} from '@klear/ui/ag-grid/klear-ag-grid-options'
import { useKlearAgGridTheme } from '@klear/ui/hooks/use-ag-grid-theme'

export function useKlearAgGrid() {
  const theme = useKlearAgGridTheme()
  return useMemo(
    () => ({
      theme,
      columnTypes: KLEAR_AG_GRID_COLUMN_TYPES,
      dataTypeDefinitions: KLEAR_AG_GRID_DATA_TYPE_DEFINITIONS,
      defaultColDef: KLEAR_AG_GRID_DEFAULT_COL_DEF
    }),
    [theme]
  )
}
